import { connect } from 'react-redux';
import { useEffect } from 'react';
import orderCompleteImage from '../../images/order-complete.svg'
import './order-status.css';
import { retriveOrder } from '../../actions'
import Card from '../utils/Card';
import TextPlaceHolder from '../utils/TextPlaceholder'
const OrderStatus = ({ retriveOrder, match, current_order, loading }) => {
    var order_id = match.params.order_id
    useEffect(() => {
        retriveOrder(order_id)
    }, [retriveOrder, order_id])
    const renderOrderItem = current_order ? current_order.items.map((x, i) => {
        return (
            <tr key={i}>
                <td>{x.service.name}</td>
                <td>&#8377;{x.service.price * x.quantity}</td>
            </tr>
        )
    }) : null
    return (
        <div className="order-status-container containerAF max-width">
            <img src={orderCompleteImage} alt="order-complete" className="order-complete-image"/>
            <h1>Order Placed Successfully</h1>
            <p className="order-status-description">{`Thank you, your paymant has been successfull. Invoice for your order ${order_id} has been generated and sent to your email id ${current_order?.user?.email || "---------------------"}`}</p>
                <div className="order-details__cont">
                    <div className="order-details-tables">
                        {current_order ? (<table className="ui celled table fixed table-one">
                            <tfoot>
                                <tr>
                                    <td>ORDERID</td>
                                    <td>{current_order.receipt}</td>
                                </tr>
                                <tr>
                                    <td>Coupon Applied</td>
                                    <td>{current_order?.coupon?.code ? current_order.coupon.code : "No Coupon Applied"}</td>
                                </tr>
                                <tr>
                                    <td>Discount %</td>
                                    <td>{current_order?.coupon?.discount ? current_order.coupon.discount : 0}%</td>
                                </tr>
                                <tr>
                                    <td>Payment Status</td>
                                    <td>{current_order.paid ? "Paid" : "Pending"}</td>
                                </tr>
                                <tr>
                                    <td>Status</td>
                                    <td>{current_order.status}</td>
                                </tr>
                            </tfoot>
                        </table>) : <TextPlaceHolder paragraph={4} className="table-one"/>}
                        {current_order ? (<table  className="ui celled table fixed table-two">
                            <tbody>
                            <tr>
                                <td colSpan="2">Order Items</td>
                            </tr>
                                {renderOrderItem}
                                <tr>
                                    <td>Subtotal</td>
                                    <td>&#8377;{current_order.subtotal}</td>
                                </tr>
                                <tr>
                                    <td>Discount</td>
                                    <td>&#8377;{current_order.discount}</td>
                                </tr>
                                <tr>
                                    <td>Total</td>
                                    <td>&#8377;{current_order.total}</td>
                                </tr>
                            </tbody>
                        </table>) : <TextPlaceHolder paragraph={4} className="table-two"/>}
                    </div>
                    <div className="ui divider"></div>
                    <div className="order-details__info ui cards">
                        {current_order ? (<Card header="Service Address" description={`${current_order.user.address_1} ${current_order.user.address_2} ${current_order.user.city} ${current_order.user.state} ${current_order.user.pincode}`}/>) : <TextPlaceHolder paragraph={1} className="card"/>}
                        {current_order ? (<Card header="Estimate Complete Date" description={current_order.fullfill_by} meta="Elapsed"/>) : <TextPlaceHolder paragraph={1} className="card"/>}
                        {/* <div className="order-fullfillment">
                            <h3>Estimate Complete Date</h3>
                            <p>{current_order.fullfill_by}</p>
                        </div> */}
                    </div>
                </div>
        </div>
    )
}
const mapStateToProps = (state, ownProps) => {
    const order_id = ownProps.match.params.order_id;
    let current_order;
    state.orders.data.forEach(element => {
        if (element.receipt === order_id){
            current_order = element
        }
    });
    return {
        current_order: current_order,
    }
}
export default connect(mapStateToProps, { retriveOrder })(OrderStatus);